// extracted by mini-css-extract-plugin
export default {"width-wrapper":"docTab_width-wrapper__vsGeD","widthWrapper":"docTab_width-wrapper__vsGeD"};